export default __webpack_public_path__ + "files/What_Farmers_Stand-944bcc8d8547295352af97b03cf7a22a.pdf";